import { COMMON_DATE_FORMAT } from 'constants/date';
import { FieldType } from 'constants/formGenerator';

export const PRE_INVESTOR_CONDITION_FORM_CONFIG = {
  groups: [
    {
      type: FieldType.GROUP,
      key: 'pre-investor-condition',
      fields: [
        {
          fieldId: 'conditionText',
          type: FieldType.INPUT,
          nameInModel: 'conditionText',
          inputProps: {
            label: 'Condition Text',
            variant: 'outlined',
            required: true,
            widthInColumns: 3,
            multiline: true,
            rows: 3,
          },
        },
        {
          fieldId: 'dateAdded',
          type: FieldType.DATE,
          nameInModel: 'dateAdded',
          inputProps: {
            label: 'Date Added',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: true,
            widthInColumns: 1,
          },
        },
        {
          fieldId: 'dateResponded',
          type: FieldType.DATE,
          nameInModel: 'dateResponded',
          noValidate: true,
          inputProps: {
            label: 'Date Responded',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: false,
            widthInColumns: 1,
            clearable: true,
          },
        },
        {
          fieldId: 'dateCleared',
          type: FieldType.DATE,
          nameInModel: 'dateCleared',
          noValidate: true,
          inputProps: {
            label: 'Date Cleared',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: false,
            widthInColumns: 1,
            clearable: true,
          },
        },
      ],
    },
  ],
};

export const PRE_CONDITION_TEXT_FORM_CONFIG = {
  groups: [
    {
      type: FieldType.GROUP,
      key: 'pre-condition-text',
      fields: [
        {
          fieldId: 'conditionText',
          type: FieldType.INPUT,
          nameInModel: 'conditionText',
          inputProps: {
            label: 'Condition Text',
            variant: 'outlined',
            required: true,
            widthInColumns: 1,
            multiline: true,
            rows: 4,
          },
        },
      ],
    },
  ],
};

export const PRE_CONDITION_DATES_FORM_CONFIG = {
  groups: [
    {
      type: FieldType.GROUP,
      key: 'pre-condition-dates',
      fields: [
        {
          fieldId: 'dateAdded',
          type: FieldType.DATE,
          nameInModel: 'dateAdded',
          inputProps: {
            label: 'Date Added',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: true,
            widthInColumns: 1,
          },
        },
        {
          fieldId: 'dateResponded',
          type: FieldType.DATE,
          nameInModel: 'dateResponded',
          noValidate: true,
          inputProps: {
            label: 'Date Responded',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: false,
            widthInColumns: 1,
            clearable: true,
          },
        },
        {
          fieldId: 'dateCleared',
          type: FieldType.DATE,
          nameInModel: 'dateCleared',
          noValidate: true,
          inputProps: {
            label: 'Date Cleared',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: false,
            widthInColumns: 1,
            clearable: true,
          },
        },
      ],
    },
  ],
};
